/**
 * @author Rahul Nainala
 * @description Camera functionality which re render for every frame
 */
import { useRef } from "react";
import { useFrame, useThree } from "@react-three/fiber";

function CameraController({
  cameraTarget,
  cameraPosition,
  animate,
  lerpFactor = 0.1,
  onAnimationComplete
}) {
  const { camera, controls } = useThree();
  const hasCompleted = useRef(false);
  const factorRef = useRef(lerpFactor);

  useFrame(() => {
    if (animate) {
      camera.position.lerp(cameraPosition, factorRef.current);
      controls.target.lerp(cameraTarget, factorRef.current);
      factorRef.current = Math.min(factorRef.current + 0.005, 0.1);

      if (
        camera.position.distanceTo(cameraPosition) < 0.05 &&
        controls.target.distanceTo(cameraTarget) < 0.05
      ) {
        if (!hasCompleted.current) {
          hasCompleted.current = true;
          onAnimationComplete?.();
        }
      } else {
        hasCompleted.current = false;
      }
    }
  });

  return null;
}

export default CameraController;
